
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Typography, Box, Paper, List, ListItem, ListItemText, Button } from '@mui/material';
import { roundMoney, roundSize } from '../utils/money';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';

const OrderSuccess = () => {
  const { completedId: orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const docRef = doc(db, 'orders', orderId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          const currentUser = auth.currentUser;
          if (currentUser && data.customerId === currentUser.uid) {
            setOrder(data);
          } else {

          }
        } else {

        }
      } catch (error) {
        console.error('Failed to fetch order:', error);

      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderId, navigate]);

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ mt: 8 }}>
        <Typography variant="h6" align="center">Loading your order...</Typography>
      </Container>
    );
  }

  if (!order) return null;

  return (
    <Container maxWidth="md" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom align="center">
          🎉 Transaction Successful!
        </Typography>
        <Typography variant="subtitle1" align="center" sx={{ mb: 4 }}>
          Thank you for your order. Your invoice number is <strong>{order.invoiceNumber}</strong>.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Order Summary:
        </Typography>
        <List>
          {order.pictures.map((pic, index) => (
            <ListItem key={index}>
              <ListItemText
                primary={`Image ${index + 1}`}
                secondary={`Size: ${roundSize(pic.widthIn).toFixed(2)}" x ${roundSize(pic.heightIn).toFixed(2)}" | Quantity: ${pic.quantity}`}
              />
            </ListItem>
          ))}
          <ListItem>
            <ListItemText
              primary="Total Cost"
              secondary={`$${roundMoney(order.total).toFixed(2)} (${order.paymentTerms})`}
            />
          </ListItem>
        </List>

        <Box textAlign="center" mt={4}>
          <Button variant="contained" onClick={() => navigate('/')}>
            Return Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default OrderSuccess;
